import { getPath } from '@/router/common'

const baseUrl = {
  title: '货车定位',
  path: 'TruckPositioning'
}
// /TruckPositioning/MyGPSAccountInfo
// /TruckPositioning/LocateTheQuery
// /TruckPositioning/ConsumptionRecords
// /TruckPositioning/TopUpRecords
// /TruckPositioning/QueryRecords
// /TruckPositioning/AuthorizationRecord
export default [
  {
    path: getPath('MyGPSAccountInfo', baseUrl),
    name: 'MyGPSAccountInfo',
    component: () => import(/* webpackChunkName: "MyGPSAccountInfo" */ '@/views/truckPositioning/myGPSAccountInfo/index.vue'),
    meta: {
      title: '账户充值'
    }
  },
  {
    path: getPath('LocateTheQuery', baseUrl),
    name: 'LocateTheQuery',
    component: () => import(/* webpackChunkName: "LocateTheQuery" */ '@/views/truckPositioning/locateTheQuery/index.vue'),
    meta: {
      title: '定位查询'
    }
  },
  {
    path: getPath('DevicenoLocateQuery', baseUrl),
    name: 'DevicenoLocateQuery',
    component: () => import(/* webpackChunkName: "DevicenoLocateQuery" */ '@/views/truckPositioning/devicenoLocateQuery/index.vue'),
    meta: {
      title: '设备定位查询'
    }
  },
  {
    path: getPath('ConsumptionRecords', baseUrl),
    name: 'ConsumptionRecords',
    component: () => import(/* webpackChunkName: "ConsumptionRecords" */ '@/views/truckPositioning/consumptionRecords/index.vue'),
    meta: {
      title: '消费记录'
    }
  },
  {
    path: getPath('TopUpRecords', baseUrl),
    name: 'TopUpRecords',
    component: () => import(/* webpackChunkName: "TopUpRecords" */ '@/views/truckPositioning/topUpRecords/index.vue'),
    meta: {
      title: '充值记录'
    }
  },
  {
    path: getPath('QueryRecords', baseUrl),
    name: 'QueryRecords',
    component: () => import(/* webpackChunkName: "QueryRecords" */ '@/views/truckPositioning/queryRecords/index.vue'),
    meta: {
      title: '查询记录'
    }
  },
  {
    path: getPath('AuthorizationRecord', baseUrl),
    name: 'AuthorizationRecord',
    component: () => import(/* webpackChunkName: "AuthorizationRecord" */ '@/views/truckPositioning/authorizationRecord/index.vue'),
    meta: {
      title: '授权记录'
    }
  }
  // {
  //   path: getPath('Get_CourierDetails', baseUrl),
  //   name: 'GetCourierDetails',
  //   component: () => import(/* webpackChunkName: "Get_CourierDetails" */ '@/views/courier/getCourierDetails/index.vue'),
  //   meta: {
  //     title: '快递单明细'
  //   }
  // }
]
